import React from "react";
import PropTypes from "prop-types";

export const FeedCardHeaderTitle = ({ children, className = "" }) => (
  <h3 className={`media__title ${className}`}>{children}</h3>
);

FeedCardHeaderTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default FeedCardHeaderTitle;
